import React from "react"
import PropTypes from "prop-types"

import styles from "./Label.module.css"

const labelTypes = {
  legend: "legend",
  primary: "primary",
  secondary: "secondary",
}

class Label extends React.Component {
  render() {
    let labelClass = styles.label

    if (this.props.type === labelTypes.secondary) {
      labelClass = styles.labelSecondary
    }

    if (this.props.type === labelTypes.legend) {
      return (
        <legend htmlFor={this.props.htmlFor} className={labelClass}>
          {this.props.children}
        </legend>
      )
    } else {
      return (
        <label htmlFor={this.props.htmlFor} className={labelClass}>
          {this.props.children}
        </label>
      )
    }
  }
}

Label.defaultProps = {
  type: labelTypes.primary,
}

Label.propTypes = {
  type: PropTypes.oneOf([
    labelTypes.primary,
    labelTypes.legend,
    labelTypes.secondary,
  ]),
}

export default Label
